import fetcher from '../../modules/ajio-fetch';
import { fetchGetJSONResHandler, getFetcherHeader } from '../../modules/ajio-fetch/utils';
import endpoints from '../../modules/ajio-util/endpoints';
import { getProductProps } from '../../refresh/utils/productUtils';
import { sha256Hex } from '../../utils/products';

export const RECOMMENDATION_WIDGET_FETCH = 'RECOMMENDATION_WIDGET_FETCH';
export const RECOMMENDATION_WIDGET_SUCCESS = 'RECOMMENDATION_WIDGET_SUCCESS';
export const RECOMMENDATION_WIDGET_FAILURE = 'RECOMMENDATION_WIDGET_FAILURE';

export const recommendationWidgetsFetch = pageType => ({
  type: RECOMMENDATION_WIDGET_FETCH,
  payload: { pageType }
});

export const recommendationWidgetsSuccess = (pageType, widgetsData) => ({
  type: RECOMMENDATION_WIDGET_SUCCESS,
  payload: { pageType, widgetsData }
});

export const recommendationWidgetsFailure = (pageType, error) => ({
  type: RECOMMENDATION_WIDGET_FAILURE,
  payload: { pageType, error }
});

function fetchOsmosAdsProductsDetailsSuccess(response) {
  return {
    type: 'FETCH_OSMOS_ADS_PRODUCTS_DETAIL_SUCCESS',
    payload: { jioAdsProducts: response }
  };
} 

function fetchOsmosAdsProductsDetailsFailue(error) {
  return {
    type: 'FETCH_JIOADS_PRODUCTS_DETAIL_FAILURE',
    payload: {
      loading: false,
      data: [],
      error
    }
  };
}

const transformWidgetData = widgets => {
  return widgets.map(el => {
    const newWidget = {};
    const { position = 0, cmsSettings , component  } = el;
    newWidget['rowNumber'] = position;
    newWidget['position'] = position;
    newWidget['component'] = (component || cmsSettings) || {};


    return newWidget;
  });
};

export const fetchWidgetsData = (req, pageType) => {
  return async function(dispatch) {
    const { store = 'AJIO', device: { type = '' } = {}, cookies = {}, deviceType = '' } = req;
    const { customerType = 'NEW', LS = '', CI = '' } = cookies;
    const platform = (type  === 'phone' || deviceType === 'mobile')  ? 'MOBILE' : 'WEB';
    const channel = (type  === 'phone' || deviceType === 'mobile') ? 'msite' : 'desktop';
    const userType = customerType.toUpperCase();
    const userState = LS === 'LOGGED_IN' ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const userId = CI;
    const outOfStock = false;
    const apiVersion = 'v1';

    if (platform !== 'MOBILE') return;

    dispatch(recommendationWidgetsFetch(pageType));

    try {
      const apiEndPoint = `${endpoints.get(
        'recommendationWidget'
      )}?store=${store}&pageType=${pageType}&platform=${platform}&userType=${userType}&userState=${userState}&channel=${channel}&userId=${userId}&OutOfStock=${outOfStock}&apiVersion=${apiVersion}`;
      const headerInfo = getFetcherHeader(req);
      const response = await fetcher(apiEndPoint, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          tenantId: 'AJIO',
          ...headerInfo
        }
      });
      const parsedResponse = await fetchGetJSONResHandler(response);

      const modifiedResponse = {
        ...parsedResponse,
        data: { ...parsedResponse.data, widgets: transformWidgetData(parsedResponse.data.widgets) }
      };

      dispatch(recommendationWidgetsSuccess(pageType, modifiedResponse));
    } catch (error) {
      const errorMsg = error?.message || 'Failed to fetch recommendation widget data';
      dispatch(recommendationWidgetsFailure(pageType, errorMsg));

      console.error('Error fetching recommendation widgets data:', error);
    }
  };
};

export const fetchWidgetsDataOsmos = (req, pageType) => {
  return async function(dispatch) {
    const { store = 'AJIO', device: { type = '' } = {}, cookies = {}, deviceType = '', params={} } = req;
    const { id } = params;
    const { customerType = 'NEW', LS = '', CI = '', segment_device_id='' } = cookies;
    const platform = (type  === 'phone' || deviceType === 'mobile')  ? 'MOBILE' : 'WEB';
    const channel = (type  === 'phone' || deviceType === 'mobile') ? 'msite' : 'desktop';
    const userType = customerType.toUpperCase();
    const userState = LS === 'LOGGED_IN' ? 'LOGGED_IN' : 'NON_LOGGED_IN';
    const isLoggedIn = LS === 'LOGGED_IN';
    const userId = isLoggedIn ? sha256Hex(CI) : sha256Hex(segment_device_id);
    const outOfStock = false;
    const apiVersion = 'v1';
    const adSource = 'OSMOS';

    if (platform !== 'MOBILE') return;

    dispatch(recommendationWidgetsFetch(pageType));

    try {
      const apiEndPoint = `${endpoints.get(
        'recommendationWidgetOsmos'
      )}?store=${store}&pageType=${pageType}&platform=${platform}&userType=${userType}&userState=${userState}&channel=${channel}&userId=${userId}&OutOfStock=${outOfStock}&apiVersion=${apiVersion}&optionCode=${id}&adSource=${adSource}`;
      const headerInfo = getFetcherHeader(req);
      const response = await fetcher(apiEndPoint, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          tenantId: 'AJIO',
          ...headerInfo
        }
      });
      
      const productsObject = {};
      const parsedResponse = await fetchGetJSONResHandler(response);

      parsedResponse?.data?.widgets.forEach(widget => {
        if (Array.isArray(widget.adProducts) && widget.adProducts.length > 0) {
          productsObject[`jioAdsProducts${widget.position}`] = getProductProps(widget.adProducts);
        }
      });

      const modifiedResponse = {
        ...parsedResponse,
        data: { ...parsedResponse.data, widgets: transformWidgetData(parsedResponse.data.widgets) }
      };

      dispatch(recommendationWidgetsSuccess(pageType, modifiedResponse));
      dispatch(fetchOsmosAdsProductsDetailsSuccess(productsObject));

    } catch (error) {
      const errorMsg = error?.message || 'Failed to fetch recommendation widget data';
      dispatch(recommendationWidgetsFailure(pageType, errorMsg));
      dispatch(fetchOsmosAdsProductsDetailsFailue(errorMsg));
      console.error('Error fetching recommendation widgets data:', error);
    }
  };
};
